var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-wrapper"},[_c('navbar'),_c('div',{staticClass:"news-inner flex",style:({ 'height': !!_vm.is_web ? 'calc(100% - 60px)' : 'calc(100% - 56px)' })},[_c('app-main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }